namespace Gamification.Administration {
    export class LanguageColumns {
        static columnsKey = 'Administration.Language';
    }
}
